/**
 * Preserve kiosk handoff fields across scan ↔ register ↔ welcome navigations.
 */
export function buildKioskNavState(locationState = null, extras = {}) {
  const src = locationState && typeof locationState === 'object' ? locationState : {};
  const next =
    extras.next !== undefined
      ? extras.next
      : src.next != null
        ? src.next
        : null;
  const mode =
    extras.mode !== undefined
      ? extras.mode
      : src.mode ||
        (typeof next === 'string' && next.startsWith('/naturals/salon') ? 'salon' : null);

  const state = {
    token: extras.token !== undefined ? extras.token : src.token || null,
    deviceInfo: extras.deviceInfo !== undefined ? extras.deviceInfo : src.deviceInfo || null,
  };
  if (next != null) state.next = next;
  if (mode) state.mode = mode;
  return state;
}
